import L from "../node_modules/leaflet"
import * as draw from "../node_modules/leaflet-draw"
import * as easy_button from "../node_modules/leaflet-easybutton"
import * as sidebar from "../node_modules/leaflet-sidebar"
import * as condensed from "../Leaflet.CondensedAttribution-master/dist/leaflet-control-condended-attribution.js"
//import Vue from "../node_modules/vue/dist/vue.esm.browser.js"


var q_map = L.map('questionnaire_map_viewer',{
  'condensedAttributionControl':false,
  tap:false,
  zoomControl: false
});


/********************/
/*    Attribution   */
/*                  */
/********************/

// set custom emblem and prefix
L.control.condensedAttribution({
  emblem: '<div class="emblem-wrap"><i class="fas fa-info-circle fa-3x" style="color:#4e7fff"></i></div>',
  prefix: 'Developed by <a href="https://savingscapes.eu/">Saving Scapes</a> project | Powered by <a href="https://www.udg.edu/ca/sigte">SIGTE-UdG</a> | &copy; <a href="https://www.mapbox.com/">Mapbox</a> | <a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
}).addTo(q_map);


/*********************/
/*    Zoom Control   */
/*                   */
/*********************/


L.control.zoom({
  position: 'bottomright'
}).addTo(q_map);


/*********************/
/*    Base maps      */
/*                   */
/*********************/


var topo_for_map = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 22,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
}).addTo(q_map);


var hybrid_for_map = L.tileLayer('https://api.mapbox.com/styles/v1/mapesbasesigte/ckp6jjgds01c718n45c25lo97/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwZXNiYXNlc2lndGUiLCJhIjoiY2s2Y2F4YnB5MDk4ZjNvb21rcWEzMHZ4NCJ9.oVtnggRtmtUL7GBav8Kstg', {
    maxZoom: 22,
    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, ' +
      'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
    id: 'mapbox/streets-v11',
    tileSize: 512,
    zoomOffset: -1
});


// fit bounds to defined extent in questionnaire
var geojson_bbox = L.geoJson(bbox_pol);
q_map.fitBounds(geojson_bbox.getBounds());

// set max bounds. Don' allow user to pan over this bounds
q_map.setMaxBounds(geojson_bbox.getBounds());
// get initial map zoom
var zoom_q_map = q_map.getZoom();
// set max zoom
q_map.setMinZoom(zoom_q_map);


var changeBasemapButtonMap = L.easyButton({
  id: 'change-basemap-questionnaire',
  position: 'bottomleft',
  states: [{
            stateName: 'hybrid_q_map',        // name the state
            icon:      'fa-map',               // and define its properties
            onClick: function(btn, map) {       // and its callback
              $("#change-basemap-questionnaire").css("background-image", "url('"+min_topo_img+"')");
              q_map.removeLayer(topo_for_map)
              q_map.addLayer(hybrid_for_map)
              btn.state('topo_q_map');    // change state on click!
            }
        }, {
            stateName: 'topo_q_map',
            icon:      'fa-map',
            onClick: function(btn, map) {
              $("#change-basemap-questionnaire").css("background-image", "url('"+min_orto_img+"')");
              q_map.removeLayer(hybrid_for_map)
              q_map.addLayer(topo_for_map)
              btn.state('hybrid_q_map');
            }
    }]
});

changeBasemapButtonMap.addTo(q_map);


/*************************************/
/*    Map Markers and Layers         */
/*    Load data from Questionnaires  */
/*************************************/


var icon_char = new L.divIcon({
  className: 'marker-icon',
  html: '<span class="location-marker fa-stack fa-2x"><i class="fas fa-map-marker fa-stack-2x" style="color:#5183fb"></i><i class="marker_overlapp_icon far fa-bookmark fa-stack-1x fa-inverse"></i></span>',
  iconSize: [50, 50],
  iconAnchor: [22, 32]
});

var icon_positive = new L.divIcon({
  className: 'marker-icon',
  html: '<span class="location-marker fa-stack fa-2x"><i class="fas fa-map-marker fa-stack-2x" style="color:#5183fb"></i><i class="marker_overlapp_icon far fa-smile fa-stack-1x fa-inverse"></i></span>',
  iconSize: [50, 50],
  iconAnchor: [22, 32]
});

var icon_negative = new L.divIcon({
  className: 'marker-icon',
  html: '<span class="location-marker fa-stack fa-2x"><i class="fas fa-map-marker fa-stack-2x" style="color:#5183fb"></i><i class="marker_overlapp_icon far fa-frown fa-stack-1x fa-inverse"></i></span>',
  iconSize: [50, 50],
  iconAnchor: [22, 32]
});

var icon_impact = new L.divIcon({
  className: 'marker-icon',
  html: '<span class="location-marker fa-stack fa-2x"><i class="fas fa-map-marker fa-stack-2x" style="color:#5183fb"></i><i class="marker_overlapp_icon fas fa-life-ring fa-stack-1x fa-inverse"></i></span>',
  iconSize: [50, 50],
  iconAnchor: [22, 32]
});

var icon_resilient = new L.divIcon({
  className: 'marker-icon',
  html: '<span class="location-marker fa-stack fa-2x"><i class="fas fa-map-marker fa-stack-2x" style="color:#5183fb"></i><i class="marker_overlapp_icon fas fa-registered fa-stack-1x fa-inverse"></i></span>',
  iconSize: [50, 50],
  iconAnchor: [22, 32]
});

var group_char_markers = L.featureGroup();
var group_positive_markers = L.featureGroup();
var group_negative_markers = L.featureGroup();
var group_impact_markers = L.featureGroup();
var group_resilient_markers = L.featureGroup();

/* Function to load characterizing markers */
function loadCharMarkers(){
  $.ajax({
    type:"GET",
    datatype: 'json',
    url: "/"+url_ajax_calls.prefix+"map_questionnaire_char_markers/"+q_num+"/",
    data:{
      class: "characteristics",
    },
    success: function(markers){
      if(markers.markers != 'error'){
        group_char_markers.clearLayers();

        for(var i=0; i<markers.markers.length; i++){

          var p = L.geoJSON(markers.markers[i], {
            pointToLayer: function(feature, latlng){
                var m = L.marker(latlng);
                m.setIcon(icon_char);
                return m;
              }
          }).bindPopup(function (layer){

            var content = '<div class="popup_char row">' +
                          '<div class="col s1"></div>'+
                          '<div class="title_popup_char col s9">'+layer.feature.geometry.properties.name+'</div>'+
                          '<div class="col s2"><i class="close_popup fas fa-times-circle" style="font-size:25px; color:white"></i></div>'+
                          '</div>';

            for(var i=0; i< layer.feature.geometry.properties.options.length; i++){
              content += '<div class="row">' +
                         '<div class="col s1"></div>' +
                         '<div class="popup_char_content col s9">'+layer.feature.geometry.properties.options[i]+'</div>' +
                         '<div class="col s2"></div>' +
                         '</div>';
            }

            content += '</br>';
            return content;

          },{closeButton:false}).on("popupopen", (e) =>{
            $('.close_popup').on("click", e =>{
              e.preventDefault();
              q_map.closePopup();
            });

            if(toc.isVisible()){
              popup_map_padding(e);
            }

            // change icon style: selected
            e.layer._icon.innerHTML = selectedIconStyle('fa-bookmark');
          }).on("popupclose", (e) =>{
            // change icon style: unselected
            //e.layer._icon.innerHTML = resetSelectedIconStyle('fa-bookmark');
            if($('#toc_char_layer').hasClass('active')) e.layer._icon.innerHTML = resetSelectedIconStyle('fa-bookmark');
          });

          group_char_markers.addLayer(p);
        }

        group_char_markers.addTo(q_map);
      }
    }
  });
}


/* Function to load positive and negative markers */
function loadPNmarkers(){
  $.ajax({
    type:"GET",
    datatype: 'json',
    url: "/"+url_ajax_calls.prefix+"map_questionnaire_pn_markers/"+q_num+"/",
    success: function(markers){
      if(markers.markers != 'error'){
        group_positive_markers.clearLayers();
        group_negative_markers.clearLayers();

        for(var i=0; i<markers.markers.length; i++){
          var p = L.geoJSON(markers.markers[i], {
            pointToLayer: function(feature, latlng){
                var m = L.marker(latlng);
                if (feature.properties.evaluation == "Positive") m.setIcon(icon_positive);
                if (feature.properties.evaluation == "Negative") m.setIcon(icon_negative);

                return m;
              }
          }).bindPopup(function(layer){
              var content = '<div class="popup_char row">' +
                            '<div class="col s1"></div>'+
                            '<div class="title_popup_char col s9">'+layer.feature.geometry.properties.name+'</div>'+
                            '<div class="col s2"><i class="close_popup fas fa-times-circle" style="font-size:25px; color:white"></i></div>'+
                            '</div>';

              content += '<div class="row">' +
                         '<div class="col s1"></div>' +
                         '<div class="popup_char_content col s9"><b>TOPIC</b>: '+layer.feature.geometry.properties.topic+ '</br></br>' +
                         layer.feature.geometry.properties.aspect_option +
                         '</div>' +
                         '<div class="col s2"></div>' +
                         '</div>';

              content += '</br>';
              return content;
          },{closeButton:false}).on("popupopen", (e) =>{
            $('.close_popup').on("click", e =>{
              e.preventDefault();
              q_map.closePopup();
            });

            if(toc.isVisible()){
              popup_map_padding(e);
            }

            // change icon style: selected
            if(e.layer.feature.geometry.properties.evaluation == "Positive") e.layer._icon.innerHTML = selectedIconStyle('fa-smile');
            if(e.layer.feature.geometry.properties.evaluation == "Negative") e.layer._icon.innerHTML = selectedIconStyle('fa-frown');

          }).on("popupclose", (e) =>{
            // change icon style: unselected

            if($('#toc_positive_layer').hasClass('active')){
              if(e.layer.feature.geometry.properties.evaluation == "Positive") e.layer._icon.innerHTML = resetSelectedIconStyle('fa-smile');
            }

            if($('#toc_negative_layer').hasClass('active')){
              if(e.layer.feature.geometry.properties.evaluation == "Negative") e.layer._icon.innerHTML = resetSelectedIconStyle('fa-frown');
            }

          });

          if(markers.markers[i].properties.evaluation == "Positive")  group_positive_markers.addLayer(p);
          if(markers.markers[i].properties.evaluation == "Negative")  group_negative_markers.addLayer(p);

        }
        group_positive_markers.addTo(q_map);
        group_negative_markers.addTo(q_map);
      }
    }
  });
}

/* Function to load impact markers */
function loadImpactMarkers(){
  $.ajax({
    type:"GET",
    datatype: 'json',
    url: "/"+url_ajax_calls.prefix+"map_questionnaire_impact_markers/"+q_num+"/",
    success: function(markers){
      if(markers.markers != 'error'){

        group_impact_markers.clearLayers();

        for(var i=0; i<markers.markers.length; i++){
          var p = L.geoJSON(markers.markers[i], {
            pointToLayer: function(feature, latlng){
                var m = L.marker(latlng);
                m.setIcon(icon_impact);
                return m;
              }
          }).bindPopup(function(layer){

            var content = '<div class="popup_char row">' +
                          '<div class="col s1"></div>'+
                          '<div class="title_popup_char col s9">'+layer.feature.geometry.properties.name+'</div>'+
                          '<div class="col s2"><i class="close_popup fas fa-times-circle" style="font-size:25px; color:white"></i></div>'+
                          '</div>';

            content += '<div class="row">' +
                          '<div class="col s1"></div>' +
                          '<div class="popup_char_content col s9">'+layer.feature.geometry.properties.option+'</div>' +
                          '<div class="col s2"></div>' +
                          '</div>';

            content += '</br>';
            return content;
          },{closeButton:false}).on("popupopen", (e) =>{
            $('.close_popup').on("click", e =>{
              e.preventDefault();
              q_map.closePopup();
            });

            if(toc.isVisible()){
              popup_map_padding(e);
            }
            // change icon style: selected
            e.layer._icon.innerHTML = selectedIconStyle('fa-life-ring');
          }).on("popupclose", (e) =>{
            // change icon style: unselected
            if($('#toc_impact_layer').hasClass('active')) e.layer._icon.innerHTML = resetSelectedIconStyle('fa-life-ring');
          });

          group_impact_markers.addLayer(p);
        }

        group_impact_markers.addTo(q_map);
      }
    }
  });
}

/* Function to load resilient markers */
function loadResilientMarkers(){
  $.ajax({
    type:"GET",
    datatype: 'json',
    url: "/"+url_ajax_calls.prefix+"map_questionnaire_resilient_markers/"+q_num+"/",
    data:{
      class: "resilient",
    },
    success: function(markers){
      if(markers.markers != 'error'){

        group_resilient_markers.clearLayers();

        for(var i=0; i<markers.markers.length; i++){
          var p = L.geoJSON(markers.markers[i], {
            pointToLayer: function(feature, latlng){
                var m = L.marker(latlng);
                m.setIcon(icon_resilient);
                return m;
              }
          }).bindPopup(function(layer){

            var content = '<div class="popup_char row">' +
                          '<div class="col s1"></div>'+
                          '<div class="title_popup_char col s9">'+layer.feature.geometry.properties.name+'</div>'+
                          '<div class="col s2"><i class="close_popup fas fa-times-circle" style="font-size:25px; color:white"></i></div>'+
                          '</div>';

            content += '<div class="row">' +
                          '<div class="col s1"></div>' +
                          '<div class="popup_char_content col s9">'+layer.feature.geometry.properties.option+'</div>' +
                          '<div class="col s2"></div>' +
                          '</div>';

            content += '</br>';
            return content;
          },{closeButton:false}).on("popupopen", (e) =>{
            $('.close_popup').on("click", e =>{
              e.preventDefault();
              q_map.closePopup();
            });

            if(toc.isVisible()){
              popup_map_padding(e);
            }
            // change icon style: selected
            e.layer._icon.innerHTML = selectedIconStyle('fa-registered');
          }).on("popupclose", (e) =>{
            // change icon style: unselected
            if($('#toc_resilience_layer').hasClass('active')) e.layer._icon.innerHTML = resetSelectedIconStyle('fa-registered');
          });

          group_resilient_markers.addLayer(p);
        }

        group_resilient_markers.addTo(q_map);
      }
    }
  });
}


loadCharMarkers();
loadPNmarkers();
loadImpactMarkers();
loadResilientMarkers();


/*************************************/
/*    Define Icon Style on select    */
/*    Icons from map                 */
/*************************************/

function selectedIconStyle(icon){
  return '<span class="location-marker fa-stack fa-2x"><i class="fas fa-map-marker fa-stack-2x" style="color:white"></i><i class="marker_overlapp_icon far '+icon+' fa-stack-1x fa-inverse" style="color:#5183fb"></i></span>'
}

function resetSelectedIconStyle(icon){
  return '<span class="location-marker fa-stack fa-2x"><i class="fas fa-map-marker fa-stack-2x" style="color:#5183fb"></i><i class="marker_overlapp_icon far '+icon+' fa-stack-1x fa-inverse"></i></span>'
}



/*************************************/
/*    Leaflet Sidebar config         */
/*                                   */
/*************************************/


var toc = L.control.sidebar('sidebar', {
  position: 'left',
  autoPan: false,
  closeButton: false
});

q_map.addControl(toc);

// Show sidebar
toc.show();

// Close sidebar
$('#close_sidebar').click(function(){
  toc.hide();
  open_toc_button.addTo(q_map);
})

var open_toc_button = L.easyButton({
  id: 'open_toc_button',
  position: 'topleft',
  states: [{
    stateName: 'open_toc_active',
    icon: 'fas fa-bars',
    onClick: function(btn, map){
      toc.show();
      open_toc_button.remove();
    }
  }]
});


/**
 * Controlls active layers on toc
 */

$('#toc_char_layer').click(function(){
  var has_class = $(this).hasClass('active');
  (has_class) ? $(this).removeClass('active') : $(this).addClass('active');
  (has_class) ? $('.close_btn', this).text('') : $('.close_btn', this).text('x');
  (has_class) ? $('.fa-stack-1x', this).css('color', '#4e7fff') : $('.fa-stack-1x', this).css('color', 'white');
  (has_class) ? $('.fa-circle', this).css('opacity', '0') : $('.fa-circle', this).css('opacity', '1');

  (has_class) ? q_map.removeLayer(group_char_markers) : group_char_markers.addTo(q_map);


});

$('#toc_positive_layer').click(function(){
  var has_class = $(this).hasClass('active');
  (has_class) ? $(this).removeClass('active') : $(this).addClass('active');
  (has_class) ? $('.close_btn', this).text('') : $('.close_btn', this).text('x');
  (has_class) ? $('.fa-stack-1x', this).css('color', '#4e7fff') : $('.fa-stack-1x', this).css('color', 'white');
  (has_class) ? $('.fa-circle', this).css('opacity', '0') : $('.fa-circle', this).css('opacity', '1');

  (has_class) ? q_map.removeLayer(group_positive_markers) : group_positive_markers.addTo(q_map);
});

$('#toc_negative_layer').click(function(){
  var has_class = $(this).hasClass('active');
  (has_class) ? $(this).removeClass('active') : $(this).addClass('active');
  (has_class) ? $('.close_btn', this).text('') : $('.close_btn', this).text('x');
  (has_class) ? $('.fa-stack-1x', this).css('color', '#4e7fff') : $('.fa-stack-1x', this).css('color', 'white');
  (has_class) ? $('.fa-circle', this).css('opacity', '0') : $('.fa-circle', this).css('opacity', '1');

  (has_class) ? q_map.removeLayer(group_negative_markers) : group_negative_markers.addTo(q_map);
});

$('#toc_impact_layer').click(function(){
  var has_class = $(this).hasClass('active');
  (has_class) ? $(this).removeClass('active') : $(this).addClass('active');
  (has_class) ? $('.close_btn', this).text('') : $('.close_btn', this).text('x');
  (has_class) ? $('.fa-stack-1x', this).css('color', '#4e7fff') : $('.fa-stack-1x', this).css('color', 'white');
  (has_class) ? $('.fa-circle', this).css('opacity', '0') : $('.fa-circle', this).css('opacity', '1');

  (has_class) ? q_map.removeLayer(group_impact_markers) : group_impact_markers.addTo(q_map);
});

$('#toc_resilience_layer').click(function(){
  var has_class = $(this).hasClass('active');
  (has_class) ? $(this).removeClass('active') : $(this).addClass('active');
  (has_class) ? $('.close_btn', this).text('') : $('.close_btn', this).text('x');
  (has_class) ? $('.fa-stack-1x', this).css('color', '#4e7fff') : $('.fa-stack-1x', this).css('color', 'white');
  (has_class) ? $('.fa-circle', this).css('opacity', '0') : $('.fa-circle', this).css('opacity', '1');

  (has_class) ? q_map.removeLayer(group_resilient_markers) : group_resilient_markers.addTo(q_map);
});



/********************/
/*    Popups        */
/*                  */
/********************/

/**
 * Moves the popup to avoid overlapp with pannel
 * @param  {[marker object]} e leaflet marker
 */

function popup_map_padding(e){
  var latlngMarker = L.latLng(e.layer.feature.geometry.coordinates[1], e.layer.feature.geometry.coordinates[0]);
  var pixelsOfMap = q_map.latLngToContainerPoint(latlngMarker)
  var popupHeight = e.popup._contentNode.clientHeight;
  var popupWidth = e.popup._contentNode.clientWidth;
  var pannelWidth = $('.title_toc').width()

  if(pixelsOfMap.x < pannelWidth + 15 + popupWidth/2){
    // control vertical position
    var mapHeight = q_map.getSize();
    let distance_x = (popupWidth/2) + 20 - (pixelsOfMap.x - pannelWidth);
    let distance_y = popupHeight + 65 - pixelsOfMap.y;

    if(pixelsOfMap.y < popupHeight){
      q_map.panBy(L.point(-distance_x,-distance_y))
    }else{
      q_map.panBy(L.point(-distance_x,0))
    }
  }
}


/*************************/
/*    Screen Full Width  */
/*                       */
/*************************/

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;

// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});


/***********************/
/*    Translate texts  */
/*                     */
/**********************/

$('.leaflet-control-zoom-in').attr('title', leaflet_texts[0]);
$('.leaflet-control-zoom-out').attr('title', leaflet_texts[1]);
